import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const initWhyUs = () => {
  values()
}

const values = () => {
  let els = document.querySelectorAll('[data-animation="values-slides"]')

  if (!els.length || window.innerWidth <= 1024) return

  els.forEach(el => {
    const slides = el.querySelectorAll('[data-el="slide"]')
    const progressBars = el.querySelectorAll('[data-progress-bar]')
    
    if (!slides.length) return

    gsap.set(progressBars, { scaleX: 0 })
    
    el.setAttribute('data-current-slide', '1')
    
    const scrollDistance = (slides.length - 1) * window.innerHeight
    
    ScrollTrigger.create({
      trigger: el,
      start: 'top top',
      end: `+=${scrollDistance}`,
      pin: true,
      scrub: 1,
      onUpdate: self => {
        const progress = self.progress
        const totalSlides = slides.length
        
        let currentSlideIndex, slideProgress
        
        if (progress >= 1) {
          currentSlideIndex = totalSlides
          slideProgress = 1
        } else {
          currentSlideIndex = Math.floor(progress * totalSlides) + 1
          slideProgress = (progress * totalSlides) % 1
        }
        
        el.setAttribute('data-current-slide', currentSlideIndex.toString())
        
        progressBars.forEach((bar, index) => {
          const barIndex = index + 1
          
          if (barIndex < currentSlideIndex) {
            gsap.set(bar, { scaleX: 1 })
          } else if (barIndex === currentSlideIndex) {
            gsap.set(bar, { scaleX: slideProgress })
          } else {
            gsap.set(bar, { scaleX: 0 })
          }
        })
      }
    })
    

  })
}

export default () => { }